import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { getPinPadTransactionsForReprint } from '../../../actions/totalpos/Totalpos';
import {
  PIN_PAD_OPERATION,
  PIN_PAD_TRANSACTION_SOURCE_TYPE,
} from '../../../config/constants';
import printPinPadVoucherReprint from '../../../utils/printers/PinPadVoucherReprint';

const PinPadVoucherButtons = ({
  sourceType,
  sourceId,
  dispatchGetPinPadTransactionsForReprint,
}) => {
  const [printing, setPrinting] = useState(false);

  const handlePrint = async (operation) => {
    const fallbackTab = window.open('', '_blank');

    setPrinting(true);
    try {
      const transactions = await dispatchGetPinPadTransactionsForReprint({
        sourceType,
        sourceId,
      });

      const operationTransactions = (transactions || []).filter(
        (transaction) => transaction.operation === operation,
      );

      if (!operationTransactions.length) {
        if (fallbackTab) fallbackTab.close();
        if (transactions)
          toastr.info(
            'Información',
            operation === PIN_PAD_OPERATION.VOID
              ? 'No hay anulaciones con POS para imprimir.'
              : 'No hay ventas con POS para imprimir.',
          );
        return;
      }

      await printPinPadVoucherReprint({
        transactions: operationTransactions,
        operation,
        fallbackTab,
      });
    } finally {
      setPrinting(false);
    }
  };

  return (
    <>
      <Button
        color="light"
        className="border"
        onClick={() => handlePrint(PIN_PAD_OPERATION.SALE)}
        disabled={printing}
      >
        <i className="fa fa-print" /> Voucher Venta POS
      </Button>{' '}
      <Button
        color="light"
        className="border"
        onClick={() => handlePrint(PIN_PAD_OPERATION.VOID)}
        disabled={printing}
      >
        <i className="fa fa-print" /> Voucher Anulación POS
      </Button>
    </>
  );
};

PinPadVoucherButtons.propTypes = {
  sourceType: PropTypes.oneOf(Object.values(PIN_PAD_TRANSACTION_SOURCE_TYPE))
    .isRequired,
  sourceId: PropTypes.number.isRequired,
  dispatchGetPinPadTransactionsForReprint: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchGetPinPadTransactionsForReprint: getPinPadTransactionsForReprint,
};

export default connect(null, mapDispatchToProps)(PinPadVoucherButtons);
